
import { FEATURE_NAME } from '../common/features'

const MODULE_ROUTE = {
    // Management
    [FEATURE_NAME.GEOFENCE_MANAGEMENT]: `/management/geofence`,
    [FEATURE_NAME.GEOFENCE_MANAGEMENT_ZONE_CREATE]: `/management/geofence/zone/create`,
    [FEATURE_NAME.GEOFENCE_MANAGEMENT_ZONE_EDIT]: `/management/geofence/zone/edit`,
    [FEATURE_NAME.GEOFENCE_MANAGEMENT_POI_CREATE]: `/management/geofence/poi/create`,
    [FEATURE_NAME.GEOFENCE_MANAGEMENT_POT_EDIT]: `/management/geofence/poi/edit`,
    [FEATURE_NAME.USER_MANAGEMENT]: `/management/user`,
    [FEATURE_NAME.OVERALL_MANAGEMENT]: `/management/overall`,
    [FEATURE_NAME.GPS_MANAGEMENT]: `/management/gps`, 
    [FEATURE_NAME.MDVR_MANAGEMENT]: `/management/mdvr`, 
    [FEATURE_NAME.DEVICE_MANAGEMENT]: `/management/device`, 
    [FEATURE_NAME.DRIVER_MANAGEMENT]: `/management/driver`, 
    [FEATURE_NAME.VEHICLE_MANAGEMENT]: `/management/vehicle`, 
    [FEATURE_NAME.VEHICLE_GROUP_MANAGEMENT]: `/management/vehicleGroup`,
    [FEATURE_NAME.RULE_ENGINE_MANAGEMENT]: `/management/rule`, 
    [FEATURE_NAME.NOTIFICATION_MANAGEMENT]: '/management/notification',
    [FEATURE_NAME.LIVE_TRACK_LINK]: '/management/livetracking',
    // Highway Surveillance Management
    [FEATURE_NAME.HIGHWAY_SURVEILLANCE_MANAGEMENT]: '/management/surveillance',
    // Maintenance Management
    [FEATURE_NAME.OVERALL_MAINTENANCE_MANAGEMENT]: '/maintenance/overall',
    [FEATURE_NAME.OVERALL_MAINTENANCE_STATE]: '/maintenance/state',
    [FEATURE_NAME.MAINTENANCE_PROFILE_MANAGEMENT]: '/maintenance/profile',
    [FEATURE_NAME.MAINTENANCE_CONFIGURATION_MANAGEMENT]: '/maintenance/configuration',
    // [FEATURE_NAME.ROUTE_MANAGEMENT]: '/management/route',
    // VAM
    [FEATURE_NAME.OVERALL_VEHICLE_ADVANCE_MAINTENANCE]: '/vam/overall',
    [FEATURE_NAME.VEHICLE_REMINDER_MANAGEMENT]: '/vam/reminder',
    [FEATURE_NAME.VEHICLE_ENTRY_MANAGEMENT]: '/vam/entry',
    [FEATURE_NAME.CREATE_SERVICE_ENTRY]: `/create-service-entry`,
    [FEATURE_NAME.EDIT_SERVICE_ENTRY]: `/edit-service-entry`,
    [FEATURE_NAME.VEHICLE_ADVANCE_MAINTENANCE_CONFIGURATION_MANAGEMENT]: '/vam/line',
    [FEATURE_NAME.VEHICLE_ISSUES_MANAGEMENT]: '/vam/issues',
    [FEATURE_NAME.CREATE_VEHICLE_ISSUE]: `/create/vehicle/issue`,
    [FEATURE_NAME.EDIT_VEHICLE_ISSUE]: `/edit/vehicle/issue`,
    //Report
    // [FEATURE_NAME.ESCALATION_CALL_REPORT]: `/report/escalation_call`,
    [FEATURE_NAME.FUEL_ANALYSIS_DASHBOARD]: `/report/analysis/fuel`,
    [FEATURE_NAME.VEHICLE_OVERALL_REPORT]: `/report/vehicle`,
    [FEATURE_NAME.DRIVER_REPORT]: `/report/driver`,
    [FEATURE_NAME.CREATE_DRIVER_INCIDENT_REPORT]: `/create/driver/incident`,
    [FEATURE_NAME.DEVICE_REPORT]: `/report/device`,
    // App Info
    [FEATURE_NAME.VEHICLE_INFORMATION_PANEL]: `/info/vehicle`,
    [FEATURE_NAME.VEHICLE_ROUTE_PLAYBACK]: `/info/route/playback`,
    [FEATURE_NAME.VIDEO_ROUTE_PLAYBACK]: `/info/video/playback`,
    [FEATURE_NAME.VEHICLE_EVENT_TRACE]: `/info/vehicle/event`,
    [FEATURE_NAME.CREATE_LIVE_TRACK_LINK]: `/create/link/livetrack`,
    [FEATURE_NAME.CREATE_USER]: `/create/user`,
    [FEATURE_NAME.UPDATE_USER]: `/update/user`,
    [FEATURE_NAME.CREATE_DRIVER]: `/create/driver`,
    [FEATURE_NAME.UPDATE_DRIVER]: `/update/driver`,
    [FEATURE_NAME.CREATE_DEVICE]: `/create/device`,
    [FEATURE_NAME.UPDATE_DEVICE]: `/update/device`,
    [FEATURE_NAME.CREATE_VEHICLE]: `/create/vehicle`,
    [FEATURE_NAME.UPDATE_VEHICLE]: `/update/vehicle`,
    [FEATURE_NAME.CREATE_VEHICLE_GROUP]: `/create/vehiclegroup`,
    [FEATURE_NAME.UPDATE_VEHICLE_GROUP]: `/update/vehiclegroup`,
    [FEATURE_NAME.CREATE_RULE]: `/create/rule`,
    [FEATURE_NAME.UPDATE_RULE]: `/update/rule`,
    [FEATURE_NAME.CREATE_RULE_TEMPLATE]: `/create/ruletemplate`,
    [FEATURE_NAME.UPDATE_RULE_TEMPLATE]: `/update/ruletemplate`,
    [FEATURE_NAME.CREATE_ROUTE]: `/create/route`,
    [FEATURE_NAME.USER_PROFILE]: `/user/profile`,
    [FEATURE_NAME.LANDING_PAGE]: `/`,
    [FEATURE_NAME.USER_HIERARCHY_MAP]: `/user/hieararchy/map`,
    // Thirty Party
    [FEATURE_NAME.GREENER_WHEELS]: `/3p/greener_wheels`
}

/**
 * Map Availability for below route
 */

const MAP_ROUTE = {
    [FEATURE_NAME.LANDING_PAGE] : MODULE_ROUTE[FEATURE_NAME.LANDING_PAGE],
    [FEATURE_NAME.CREATE_LIVE_TRACK_LINK] : MODULE_ROUTE[FEATURE_NAME.CREATE_LIVE_TRACK_LINK],
    [FEATURE_NAME.USER_PROFILE]: MODULE_ROUTE[FEATURE_NAME.USER_PROFILE],
    [FEATURE_NAME.VEHICLE_ROUTE_PLAYBACK]: MODULE_ROUTE[FEATURE_NAME.VEHICLE_ROUTE_PLAYBACK],
    [FEATURE_NAME.VIDEO_ROUTE_PLAYBACK]: MODULE_ROUTE[FEATURE_NAME.VIDEO_ROUTE_PLAYBACK],
    [FEATURE_NAME.GEOFENCE_MANAGEMENT]: MODULE_ROUTE[FEATURE_NAME.GEOFENCE_MANAGEMENT],
    [FEATURE_NAME.GEOFENCE_MANAGEMENT_ZONE_CREATE]: MODULE_ROUTE[FEATURE_NAME.GEOFENCE_MANAGEMENT_ZONE_CREATE],
    [FEATURE_NAME.GEOFENCE_MANAGEMENT_ZONE_EDIT]: MODULE_ROUTE[FEATURE_NAME.GEOFENCE_MANAGEMENT_ZONE_EDIT],
    [FEATURE_NAME.GEOFENCE_MANAGEMENT_POI_CREATE]: MODULE_ROUTE[FEATURE_NAME.GEOFENCE_MANAGEMENT_POI_CREATE],
    [FEATURE_NAME.GEOFENCE_MANAGEMENT_POT_EDIT]: MODULE_ROUTE[FEATURE_NAME.GEOFENCE_MANAGEMENT_POT_EDIT],
    [FEATURE_NAME.USER_PROFILE]: MODULE_ROUTE[FEATURE_NAME.USER_PROFILE]
}

const OVERALL_MANAGEMENT_ROUTE = {
    [FEATURE_NAME.OVERALL_MANAGEMENT]: MODULE_ROUTE[FEATURE_NAME.OVERALL_MANAGEMENT],
    [FEATURE_NAME.VEHICLE_MANAGEMENT]: MODULE_ROUTE[FEATURE_NAME.VEHICLE_MANAGEMENT],
    [FEATURE_NAME.VEHICLE_GROUP_MANAGEMENT]: MODULE_ROUTE[FEATURE_NAME.VEHICLE_GROUP_MANAGEMENT],
    [FEATURE_NAME.DEVICE_MANAGEMENT]: MODULE_ROUTE[FEATURE_NAME.DEVICE_MANAGEMENT],
    [FEATURE_NAME.DRIVER_MANAGEMENT]: MODULE_ROUTE[FEATURE_NAME.DRIVER_MANAGEMENT],
    [FEATURE_NAME.GPS_MANAGEMENT]: MODULE_ROUTE[FEATURE_NAME.GPS_MANAGEMENT],
    [FEATURE_NAME.MDVR_MANAGEMENT]: MODULE_ROUTE[FEATURE_NAME.MDVR_MANAGEMENT],
    [FEATURE_NAME.RULE_ENGINE_MANAGEMENT]: MODULE_ROUTE[FEATURE_NAME.RULE_ENGINE_MANAGEMENT],
    [FEATURE_NAME.NOTIFICATION_MANAGEMENT]: MODULE_ROUTE[FEATURE_NAME.NOTIFICATION_MANAGEMENT],
    [FEATURE_NAME.LIVE_TRACK_LINK]: MODULE_ROUTE[FEATURE_NAME.LIVE_TRACK_LINK]
}

const MAINTENANCE_MANAGEMENT_MODULE_ROUTE = {
    [FEATURE_NAME.OVERALL_MAINTENANCE_MANAGEMENT]: MODULE_ROUTE[FEATURE_NAME.OVERALL_MAINTENANCE_MANAGEMENT],
    [FEATURE_NAME.OVERALL_MAINTENANCE_STATE]: MODULE_ROUTE[FEATURE_NAME.OVERALL_MAINTENANCE_STATE],
    [FEATURE_NAME.MAINTENANCE_PROFILE_MANAGEMENT]:  MODULE_ROUTE[FEATURE_NAME.MAINTENANCE_PROFILE_MANAGEMENT],
    [FEATURE_NAME.MAINTENANCE_CONFIGURATION_MANAGEMENT]:  MODULE_ROUTE[FEATURE_NAME.MAINTENANCE_CONFIGURATION_MANAGEMENT]
}

const VAM_MODULE_ROUTE = {
    [FEATURE_NAME.OVERALL_VEHICLE_ADVANCE_MAINTENANCE]: MODULE_ROUTE[FEATURE_NAME.OVERALL_VEHICLE_ADVANCE_MAINTENANCE],
    [FEATURE_NAME.VEHICLE_REMINDER_MANAGEMENT]: MODULE_ROUTE[FEATURE_NAME.VEHICLE_REMINDER_MANAGEMENT],
    [FEATURE_NAME.VEHICLE_ENTRY_MANAGEMENT]: MODULE_ROUTE[FEATURE_NAME.VEHICLE_ENTRY_MANAGEMENT],
    [FEATURE_NAME.VEHICLE_ADVANCE_MAINTENANCE_CONFIGURATION_MANAGEMENT]: MODULE_ROUTE[FEATURE_NAME.VEHICLE_ADVANCE_MAINTENANCE_CONFIGURATION_MANAGEMENT],
    [FEATURE_NAME.VEHICLE_ISSUES_MANAGEMENT]: MODULE_ROUTE[FEATURE_NAME.VEHICLE_ISSUES_MANAGEMENT],
}

const SECONDARY_SIDEBAR_COLLAPSIBLE_ROUTE = [
    MODULE_ROUTE[FEATURE_NAME.LANDING_PAGE],
    MODULE_ROUTE[FEATURE_NAME.VEHICLE_ROUTE_PLAYBACK],
    MODULE_ROUTE[FEATURE_NAME.VIDEO_ROUTE_PLAYBACK],
    MODULE_ROUTE[FEATURE_NAME.GEOFENCE_MANAGEMENT],
    MODULE_ROUTE[FEATURE_NAME.GEOFENCE_MANAGEMENT_ZONE_CREATE],
    MODULE_ROUTE[FEATURE_NAME.GEOFENCE_MANAGEMENT_ZONE_EDIT],
    MODULE_ROUTE[FEATURE_NAME.GEOFENCE_MANAGEMENT_POI_CREATE],
    MODULE_ROUTE[FEATURE_NAME.GEOFENCE_MANAGEMENT_POT_EDIT],
    MODULE_ROUTE[FEATURE_NAME.USER_PROFILE]
]

export {
    MAP_ROUTE,
    MODULE_ROUTE,
    OVERALL_MANAGEMENT_ROUTE,
    MAINTENANCE_MANAGEMENT_MODULE_ROUTE,
    SECONDARY_SIDEBAR_COLLAPSIBLE_ROUTE,
    VAM_MODULE_ROUTE
}